import React, { useEffect, useState } from 'react'

import { InsertedPortal } from '../../controls/inserted_portal'
import { ArrowLeft, ArrowRight } from '../../images'
import { selectPlayer } from './constants'

export const CarouselFullscreenControls = () => {
  const [opacity, setOpacity] = useState(0)

  useEffect(() => {
    setOpacity(1)
  }, [])

  return (
    <>
      <InsertedPortal siblingElement={window.frameElement as HTMLElement}>
        <button
          style={{
            ...previousNextButtonStyles,
            opacity,
            marginRight: '35px',
          }}
          onClick={() => selectPlayer(-1)}
        >
          <ArrowLeft aria-hidden />
        </button>
      </InsertedPortal>
      <InsertedPortal
        siblingElement={window.frameElement as HTMLElement}
        after={true}
      >
        <button
          style={{
            ...previousNextButtonStyles,
            opacity,
            marginLeft: '35px',
          }}
          onClick={() => selectPlayer(1)}
        >
          <ArrowRight aria-hidden />
        </button>
      </InsertedPortal>
    </>
  )
}

const previousNextButtonStyles = {
  cursor: 'pointer',
  borderRadius: '50%',
  width: '50px',
  height: '50px',
  border: 'none',
  background: '#F9F9F9',
  transition: 'opacity 0.5s ease',
  pointerEvents: 'auto',
}
